import { createReducer } from '@ngrx/store'

export const initialState = {}

export const appReducer = createReducer(initialState)
